import classnames from 'classnames'
import { FieldValidator } from 'final-form'
import React, { useCallback, useRef } from 'react'
import { Field } from 'react-final-form'
import { useIntl } from 'react-intl'
import ReactSelect from 'react-select'

import styles from './Select.module.css'

export interface ISelectOption {
  value: string
  label: string
  name?: string
}

interface ISelectProps {
  label?: string
  className?: string
  name: string
  placeholder?: string
  optional?: boolean
  ariaDescription?: string
  disabled?: boolean
  validate?: FieldValidator<string>
  options: ISelectOption[],
  hidden?: boolean,
}

export const Select: React.FC<ISelectProps> = ({
  disabled = false,
  optional = false,
  name,
  label,
  placeholder,
  ariaDescription,
  className = '',
  validate = undefined,
  options,
  hidden = false,
}) => {
  const requiredValidation = useCallback((value: string, _allValues: any) => {
    if (!optional && (value == null || value === '')) {
      return 'Obavezno polje'
    } else {
      return undefined
    }
  }, [optional])

  const validatorRef = useRef<FieldValidator<string>>((value: string, allValues: any) => {
    const validations: Array<FieldValidator<string>> = []

    if (!optional) {
      validations.push(requiredValidation)
    }
    if (validate != null) {
      validations.push(validate)
    }

    return validations.reduce((message: string | undefined, fn) => (
      message == null
        ? fn(value, allValues)
        : message
      ), undefined)
  })

  return (
    <Field
      name={name}
      validate={validatorRef.current}
    >
      {({ input, meta }) => (
        <div className={classnames(styles.Select, className)} hidden={hidden}>
          { label && <label htmlFor={name}>{optional ? label : label + " *"}</label> }
          <ReactSelect
            {...input as any}
            {...meta}
            className={classnames({ [styles.FullWidth]: true, 'is-invalid': meta.touched && meta.error })}
            name={name}
            options={options}
            isClearable
            placeholder={placeholder}
            id={name}
            aria-describedby={ariaDescription}
            isDisabled={disabled}
            styles={{
              // Fixes the overlapping problem of the component
              menu: provided => ({ ...provided, zIndex: 9999 })
            }}
          />
          { meta.touched && meta.error && <div className='invalid-feedback'>{meta.error} '{label?.replace(":", "") ?? 'Valuta inozemne mirovine'}'</div> }
          { ariaDescription && (
            <span
              id={`help-${name}`}
              className={classnames('form-text text-muted', styles.AriaDescription)}
            >
              { ariaDescription }
            </span>
          ) }
        </div>
      )}
    </Field>
  )
}
